import BaseApi from '~/api/base';
class ProjectDocumentComparisons extends BaseApi {
    constructor() {
        super('/project-document-comparisons');
    }
}
const ProjectDocumentComparisonsApi = new ProjectDocumentComparisons();
export default ProjectDocumentComparisonsApi;
